import { getMenuData, getMenuLevelList } from '@dbl/services/global';
import { useRequest } from "ahooks";
import { handleMenuData } from "./_utils";
import { useEffect, useMemo } from "react";
import { shallowEqual, useSelector } from "umi";

// 在引用PublishModal的页面外部调用hooks，在组件中调用会造成重复请求，且接口慢的话会导致下拉为空
export const useGetMenuList = () => {
  const currentGame = useSelector((state: any) => state?.datalab?.currentGame, shallowEqual);

  const { game_code: gameCode, studio, third_party_game: thirdPartyGame } = currentGame || {};

  const requestMenuData = () => {
    const params = {
      game_code: gameCode
    };
    return getMenuData(params);
  };

  const { data,loading: menuLoading,error: menuError, run: requestMenuDataList }: any = useRequest(requestMenuData, {
    manual: true,
    onError: (e) => {
      console.log('获取menu信息失败: ', e);
    },
  });

  const requestLevelData = () => {
    const params = {
      game_code: gameCode,
      studio_code: studio,
      third_party_game: thirdPartyGame,
      system: 'datalab', // 后端要求增加system参数
    };
    return getMenuLevelList(params);
  };

  const { data: levelList,loading: levelLoading,error: levelError, run: requestLevelDataList }: any = useRequest(requestLevelData, {
    manual: true,
    onError: (e) => {
      console.log('获取level信息失败: ', e);
    },
  });

  const { menuList = [], folderList = [], subFolderList = [] } = useMemo(() => handleMenuData(data?.menu_list || []) as any, [data]);

  useEffect(() => {
    requestMenuDataList();
    requestLevelDataList();
  }, [gameCode]);
  
  return {
    menuLoading,
    menuError,
    menuList,
    folderList,
    subFolderList,
    levelLoading,
    levelError,
    levelList
  };
};